import React from "react";
import AddBtn from "../AddBtn";
import { useSelector } from "react-redux";

const RepeatableContainer = ({renderForm, reducerName, keyName, showAddBtn=false, onChange}) => {
    const formData = useSelector((state) => state[reducerName][keyName]);
    return (
        <>
            {(renderForm) ? renderForm({formData, onChange}) : null}
            {showAddBtn && <AddBtn text="Add" className="reconAddBtn" />}
        </>
    );
}
 
export default RepeatableContainer;